import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './loginPage.css';
import '../../components/common/style.css';
import '../../components/common/responsive.css';
import selsmartLogo from '../../assets/images/selsmart.png';
import GoogleLogo from '../../assets/images/Google_icon.png';
import FbLogo from '../../assets/images/fb_icon.png';
import { useUser } from '../../contexts/userContext';
import Page from '../notFound/seoMetaPage';
import MetaTagsWrapper from '../notFound/seoMetaPage';

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const returnUrl = location.state?.returnUrl;
    const product = location.state?.product;
    const cartId = location.state?.cart_id;
    const session_code = location.state?.session_code;
    const slug = location.state?.slug;
    const [mobileNo, setMobileNo] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false); // New loading state
    const { setUserId, setUsername, setAuthToken,fetchCsrfToken } = useUser();
    const nameInputRef = useRef<HTMLInputElement>(null);
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const version = process.env.REACT_APP_VERSION;
    let utmQuery = location.state?.utmQuery
    utmQuery = utmQuery || ""
    

    useEffect(() => {
        //console.log("utm query login page",utmQuery)
        if (nameInputRef.current) {
            nameInputRef.current.focus();
        }
        
    }, [mobileNo]);

    const handleVerifyOtpRedirect = async () => {
        setShowError(false);
        if (!mobileNo || mobileNo.trim() === '') {
            setError('Please enter 10 digits mobile number');
            setTimeout(() => setError(null), 30000); // Clear error after 2 seconds
            return;
        }

        setLoading(true); // Set loading to true

        try {
            const csrfToken = await fetchCsrfToken();
            const response = await fetch(`${backendUrl}api/v1/login`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-CSRF-Token': csrfToken,
                },
                credentials: "include",
                body: JSON.stringify({ mobile_no: mobileNo }),
                
            });

            const data = await response.json();
            if (data.result && data.result.id) {
                
                setUsername(data.result.name);
                setAuthToken(data.result.remember_token);
                const urlPageLogin = window.location.pathname;

                // Navigate after setting user context
                sessionStorage.setItem('mobileNumber', JSON.stringify(mobileNo));
                navigate('/verify-otp', { state: { user_id: data.result.id, returnUrl, product, user: data.result, cart_id: cartId, session_code: session_code, urlLoginPage: urlPageLogin, slug: slug,utmQuery } });
                window.scrollTo({ top: 0, behavior: 'smooth' })
            } else {
                setError('Either mobile no is not registered or its disabled');
                setTimeout(() => setError(null), 30000); // Clear error after 2 seconds
            }
        } catch (err: any) {
            // setError(err.message);
            setTimeout(() => setError(null), 30000); // Clear error after 2 seconds
        } finally {
            setLoading(false); // Reset loading state
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.replace(/\D/g, ''); // Allow only numbers
        setMobileNo(value);
        setShowError(value.length > 0 && value.length < 10);
        if (mobileNo.startsWith('0') && value.length == 10 ) {
            // console.log("erororororoooooo")
            setError('Please enter a correct mobile number');
           // Clear error after 3 seconds
            return;
        }
        // Clear the error message when the user starts typing
        if (error) {
            setError(null);
        }
    };


    const handleFocus = () => {
        // Clear the error message when the input gains focus
        setError(null);
    };
    const handleLogo = () => {
        navigate('/')
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    useEffect(() => {
        fetchSeoMetaDetails()
      },[]);

    const fetchSeoMetaDetails = async () => {
        try {
            const code = 'login_page'
            const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
                {  method: 'GET',
                    headers:{
                      // Accept:'aplication/json',
                      "Content-Type": "application/json"
              
                    },
                  
               credentials: "include",
                        mode:"cors"
                  }
            );
            if (!response.ok) throw new Error('Failed to fetch categories');
            const data = await response.json();
            await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
        } catch (error) {
            //console.error('Error fetching categories:', error);
        }
      };
      
      const changeTitleAndMetaTags = async (
        title: string,
        metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
      ) => {
        try {
            // Update the document title

            if (title) {
                document.title = title;
            } else {
                document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            }
      
            // Update or create meta tags
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    // Update existing meta tag
                    metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
                } else {
                    // Create new meta tag if it doesn't exist
                    const newMetaTag = document.createElement('meta');
                    newMetaTag.name = metaName;
                    newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                    document.head.appendChild(newMetaTag);
                }
            });
      
            // Cleanup function to reset the title and meta tags when unmounting
            return () => {
                document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
                Object.keys(metaTags).forEach((metaName) => {
                    const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                    if (metaTag) {
                        metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                    }
                });
            };
        } catch (error) {
            //console.error("Error updating title and meta tags:", error);
        }
      };

      const currentYear = new Date().getFullYear();

    return (
        <div>
            <MetaTagsWrapper pageCode="login_page"></MetaTagsWrapper>
            <nav className="navbar navbar-expand-lg bg-white- login_screen">
                <div className="container-fluid">
                    <a className="navbar-brand">
                        <img src={selsmartLogo} alt="logo" onClick={handleLogo} />
                    </a>
                    {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button> */}
                    <div className="collapse- navbar-collapse-" id="navbarSupportedContent-">
                        <ul className="navbar-nav mb-2- mb-lg-0 ms-auto">
                            <li className="nav-item">
                                <a className="nav-link active" aria-current="page" href="/">Home</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <div className="container-fluid sign_in">
                <div className="row">
                    <div className="col-6 green_bg position-relative">
                        <div className="right-side">
                            <h1>Welcome to <br /><span className="selsmart-heading">Selsmart</span></h1>
                            <p className="welcome-text">Sell your used<br className="view" /> electronic appliances in <br className="view" /> smart way with us!</p>
                            <hr className="white-line" />
                        </div>
                    </div>
                    <div className=" white_bg_right col-6">
                        <div className="left-side">
                            <div className="login-content- form-container">
                                <h2>Welcome Back <span>👋</span></h2>
                                <p>Today is a new day. It's your day. You shape it. Sign in to start managing your projects.</p>
                                <form
                                    id="signupForm"
                                    onSubmit={(e) => {
                                        e.preventDefault(); // Prevent form submission
                                        // handleVerifyOtpRedirect(); // Trigger your custom function
                                    }}
                                >
                                    <div className="input-group">
                                        <label>
                                            Mobile No.
                                            <p className="required">*</p>
                                        </label>

                                        <input
                                            type="text"
                                            className={`login-input ${showError && mobileNo.length > 0 ? 'error-msg' : ''}`}
                                            placeholder="+91-9999999999"
                                            ref={nameInputRef}
                                            onChange={handleChange}
                                            onFocus={handleFocus}
                                            maxLength={10}
                                            value={mobileNo}
                                            onKeyPress={(event) => {
                                                if (event.key === 'Enter') {
                                                    handleVerifyOtpRedirect();
                                                }
                                            }}
                                        />

                                        {showError && mobileNo.length > 0 && (
                                            <p className="error-message-login ">10 digits required</p>
                                        )}
                                    </div>

                                    {error && (
                                        <div className="error-login-page">
                                            {error.split('.').map((sentence, index) => (
                                                <p className='error-login-without-register' key={index}>
                                                    {sentence.trim()}
                                                    {index < error.split('.').length - 1 && '.'}
                                                </p>
                                            ))}
                                        </div>
                                    )}
                                    <button
                                        className='login-button submit-btn'
                                        type="button"
                                        onClick={handleVerifyOtpRedirect}
                                        disabled={loading || mobileNo.length !== 10} // Disable if loading or mobileNo isn't 10 digits
                                    >
                                        {loading ? 'Logging in...' : 'Login'}
                                    </button>
                                </form>
                                <div className="social-signin">
                                    {/* <p>Or sign in with</p> */}
                                    {/* <div className="social-buttons for_web">
                                        <button className="social-btn google-btn"> <img src={GoogleLogo} alt="google Logo" /> Sign in with Google</button>
                                        <button className="social-btn facebook-btn"><img src={FbLogo} alt="google Logo" /> Sign in with Facebook</button>
                                    </div> */}

                                    {/* <div className="social-buttons for_mobile">
                                        <button className="social-btn google-btn"> <img src={GoogleLogo} alt="google Logo" />Google</button>
                                        <button className="social-btn facebook-btn"><img src={FbLogo} alt="google Logo" />Facebook</button>
                                    </div> */}
                                </div>
                                <p className='signup-link'>Don't you have an account? <a onClick={() => navigate('/register', { state: { returnUrl, product, cart_id: cartId, session_code: session_code,utmQuery } })}> Sign up</a></p>
                            </div>
                        </div>
                        <div className="copy_right">© {currentYear} All rights reserved.</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
